import React from 'react'

export const LimitMessage = ({ name }) => <>{name && <b>{name}</b>}</>
